import {
  nthArg,
  compose,
  prop,
  __,
  converge,
  or,
  dec,
  path,
  ifElse,
  always,
  identity,
  applySpec,
} from 'ramda';

import {
  productOrderDesktop,
  productsLength,
} from 'app/features/products/selectors';
import {
  PRODUCTS_LEFT,
  PRODUCTS_CENTER,
  PRODUCTS_RIGHT,
} from 'app/analytics/constants/positions';
import {
  referrer,
  getOfferId,
  referrerURL,
  pageNameFromRouterPath,
  getMarketingReferrerFromUrl,
} from 'app/router/selectors';
import { ExternalReferrer, contentMedia } from 'app/analytics/helpers';
import { ORGANIC, PAID_CAMPAIGN } from 'app/analytics/constants/app';
import { campaignReferrer } from 'app/features/deltaConfig/selectors';
import { mediaByPropsId } from 'app/features/series/selectors';
import { userCountryCode } from 'app/features/user/selectors';

const PRODUCTS_POSITION_BY_NUMBER_OF_PRODUCTS = {
  2: [PRODUCTS_LEFT, PRODUCTS_RIGHT],
  3: [PRODUCTS_LEFT, PRODUCTS_CENTER, PRODUCTS_RIGHT],
};
const productPosition = converge(
  compose(path(__, PRODUCTS_POSITION_BY_NUMBER_OF_PRODUCTS), Array.of),
  [productsLength, compose(dec, productOrderDesktop)],
);

const positionFromProps = compose(prop('position'), nthArg(1));

const position = converge(or, [positionFromProps, productPosition]);

const commonActionDetail = converge(
  (pageOrScreen, referrer) => ({ pageOrScreen, referrer }),
  [pageNameFromRouterPath, referrer],
);

const contentMediaById = compose(contentMedia, mediaByPropsId);

const referrerId = compose(
  ifElse(Boolean, identity, always(ORGANIC)),
  getOfferId,
);

const referrerType = compose(
  ifElse(Boolean, always(PAID_CAMPAIGN), always(ORGANIC)),
  getOfferId,
);

const referrerName = converge(or, [
  getMarketingReferrerFromUrl,
  campaignReferrer,
]);

const getAnalyticsInitConfig = applySpec({
  countryCode: userCountryCode,
});

const externalReferrer = compose(
  ExternalReferrer,
  applySpec({
    referrerId,
    referrerURL,
    referrerType,
    referrerName,
    referrerLink: always(document.referrer),
  }),
);

export {
  position,
  commonActionDetail,
  externalReferrer,
  referrerName,
  contentMediaById,
  getAnalyticsInitConfig,
};
